import React, { useEffect, useMemo, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";

export const TranscriptBulkEditorDialog = ({
  open,
  onOpenChange,
  transcript = "",
  language = "es",
  loading = false,
  onSave,
}) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    if (!open) return;
    setValue(transcript || "");
  }, [open, transcript]);

  const copy = useMemo(() => language === "es" ? {
    title: "Editar transcripción completa",
    description: "Puedes corregir todo el texto. Si respetas un bloque por fragmento, los tiempos quedan mejor alineados.",
    helper: "Sugerencia: deja un bloque por fragmento separado por una línea en blanco cuando quieras conservar el reparto actual.",
    save: "Guardar transcripción",
  } : {
    title: "Edit full transcript",
    description: "You can fix the entire text. If you keep one block per segment, timing stays better aligned.",
    helper: "Tip: keep one block per segment separated by a blank line if you want to preserve the current split.",
    save: "Save transcript",
  }, [language]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-4xl" data-testid="transcript-bulk-editor-dialog">
        <DialogHeader>
          <DialogTitle data-testid="transcript-bulk-editor-title">{copy.title}</DialogTitle>
          <DialogDescription data-testid="transcript-bulk-editor-description">{copy.description}</DialogDescription>
        </DialogHeader>

        <div className="space-y-4">
          <div className="rounded-2xl border border-border bg-muted/20 px-4 py-3 text-xs leading-6 text-muted-foreground" data-testid="transcript-bulk-editor-helper">
            {copy.helper}
          </div>

          <Textarea
            value={value}
            onChange={(event) => setValue(event.target.value)}
            className="min-h-[420px]"
            data-testid="transcript-bulk-editor-textarea"
          />

          <div className="flex justify-end">
            <Button
              type="button"
              onClick={() => onSave?.(value)}
              disabled={loading || !value.trim()}
              data-testid="transcript-bulk-save-button"
            >
              {copy.save}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
